import React, { useEffect, useState } from "react";
import "./productos.css";
import SliderHome from "../SliderHome/SliderHome";
import { apiGet } from "../../../api/api";

const Productos = ({ data, urlMainData, showBanner }) => {
    const [clientData, setClientData] = useState([]);
    const [banner, setBanner] = useState([]);

    useEffect(() => {
        apiGet('/nuestros-productos')
            .then(res => {
                const allItems = res.flatMap(item => {
                    return item.bannerPrincipal;
                });
                setBanner(allItems);
            })
            .catch(err => {
                console.error('❌ Error al obtener características:', err);
            });
    }, []);

    useEffect(() => {
        setClientData(data);
    }, [data]);

    if (clientData.length === 0) return null;

    const strapiBase = process.env.REACT_APP_STRAPI_API_BASE.replace('/api', '');

    // console.log("client data", clientData);

    return (
        <>
            {showBanner && (
                <SliderHome
                    desktopVideoId={banner[0]?.idVideoYTEscritorio}
                    mobileVideoId={banner[0]?.idVideoYTMobile}
                />
            )}
            <div className="container container-product">
                {clientData.map((category, categoryIndex) => {
                    // Reunimos todos los slides con su info
                    const allSlides = category.products.flatMap((product) =>
                        product.images.map((image) => ({
                            ...image,
                            productSlug: product.slug
                        }))
                    );

                    return (
                        <div className="row product-container" key={categoryIndex}>
                            <div
                                className={`col-md-6 d-flex flex-column justify-content-center ${categoryIndex % 2 === 0 ? "" : "order-md-2"}`}
                            >
                                <h1 className="product-category-title">
                                    <a href={`${urlMainData}/${category.slug}`}>
                                        {category.category}
                                    </a>
                                </h1>
                                <p>{category.description}</p>
                            </div>
                            <div className={`col-md-6 ${categoryIndex % 2 === 0 ? "order-md-2" : ""}`}>
                                <div id={`carousel-home-products-${categoryIndex}`} className="carousel slide" data-bs-ride="false">
                                    <div className="carousel-indicators">
                                        {allSlides.map((_, index) => (
                                            <button
                                                key={index}
                                                type="button"
                                                data-bs-target={`#carousel-home-products-${categoryIndex}`}
                                                data-bs-slide-to={index}
                                                className={index === 0 ? "active" : ""}
                                                aria-current={index === 0 ? "true" : undefined}
                                                aria-label={`Slide ${index + 1}`}
                                            ></button>
                                        ))}
                                    </div>
                                    <div className="carousel-inner">
                                        {allSlides.map((image, index) => (
                                            <div key={index} className={`carousel-item ${index === 0 ? "active" : ""}`}>
                                                <div className="carousel-bg" style={{
                                                    backgroundImage: `url(${strapiBase}${image.urlCategory})`,
                                                }}>
                                                    <div className="overlay-product">
                                                        <a href={`${urlMainData}/${category.slug}/${image.productSlug}`}>
                                                            <h5>{image.title}</h5>
                                                            {/* <p>{image.description}</p> */}
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <button className="carousel-control-prev" type="button" data-bs-target={`#carousel-home-products-${categoryIndex}`} data-bs-slide="prev">
                                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                        <span className="visually-hidden">Previous</span>
                                    </button>
                                    <button className="carousel-control-next" type="button" data-bs-target={`#carousel-home-products-${categoryIndex}`} data-bs-slide="next">
                                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span className="visually-hidden">Next</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default Productos;
